module.exports = __webpack_public_path__ + "static/leaflet2026-03d27b91fc0485cad6a5a67e7eb908f0.pdf";